const selectOnlineOrderingLocationBySlug = locationSlug => state => {
  const id =
    state.restaurantLocations.allIds?.filter(
      id =>
        state.restaurantLocations.byId?.[id]?.location?.slug === locationSlug
    )?.[0] ?? null;

  return state.restaurantLocations.byId?.[id] ?? {};
};

export default selectOnlineOrderingLocationBySlug;
